module.exports = __webpack_public_path__ + "static/media/promotion.990da38b.png";